<div class="modal-header">
  <h4 class="modal-title">{{ "sphere.account.add_card" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  @if (loading) {
    <myp-inline-loader [loading]="true" height="200px" spinnerName="updatePaymentSourceLoader"></myp-inline-loader>
  }
  <div [hidden]="loading">
    <myp-stripe-payment #stripePaymentCmp [addingNewCard]="true" [showPaymentForm]="true" [showCouponButton]="false" [showHelptext]="false"></myp-stripe-payment>
    <div class="container">
      <div class="row">
        <div class="form-group col-sm-12 col-md-12">
          @if (userService.subDetails?.subscription?.provider_subscription_id) {
            <myp-switch
              extraClasses="m-b-10"
              [active]="setAsDefaultForSubscription"
              label="Use this card for my Studio One Pro+ subscription."
              [labelToRight]="true"
              (toggle)="setAsDefaultForSubscription = !setAsDefaultForSubscription"
            ></myp-switch>
          }
        </div>
      </div>
    </div>
  </div>
</div>
@if (!checkoutService.loadingCheckout) {
  <div class="modal-footer">
    @if (!isBlueSnapSubscription) {
      <button type="button" class="btn btn-primary" [disabled]="loading || !checkoutService.newPaymentMethod" (click)="submit()">
        {{ "general.submit" | translate }}
      </button>
    }
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
